import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

// Components
import SEO from "../components/seo"

// Styles
import "../styles/generic.scss"
import "../components/imageHeader.scss"

import Layout from "../components/layout"

const IndexPage = props => (
  <Layout>
    <SEO title="Home" keywords={[`Daisy`, `Godfrey`, `Nottingham`, `Singer`]} />
    <div className="header__image">
      <Img
        fluid={props.data.daisyHeader.childImageSharp.fluid}
        alt="Daisy Godfrey"
      />
    </div>
  </Layout>
)

export default IndexPage

export const pageQuery = graphql`
  query {
    daisyHeader: file(relativePath: { eq: "daisy_header.jpg" }) {
      childImageSharp {
        fluid(
          maxWidth: 2000
          traceSVG: { background: "#fff", color: "#eb6e78", turdSize: 1 }
        ) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
